<template>
  <div
    class="gradient-transition-effect a group z-0 min-h-[7.875rem] w-full bg-gradient-to-tr from-blue-50/40 to-blue-10/40 px-8 py-6 after:bg-gradient-to-tr after:from-blue-100/50 after:to-blue-50/50"
  >
    <!-- DATE -->
    <h3 class="mb-4 w-full text-2xl font-medium leading-8 sm:mb-3">
      <time :datetime="data.date_from">
        {{ formatDateFull(data.date_from) }}
      </time>
      <template v-if="data.date_end">
        -
        <time :datetime="data.date_end">
          {{ formatDateFull(data.date_end) }}
        </time>
      </template>
    </h3>

    <!-- META -->
    <ul class="flex-wrap items-center justify-between gap-5 md:flex">
      <li class="mb-4 mr-[25%] flex justify-between gap-5 md:mb-0 md:mr-0">
        <!-- LOCATION -->
        <div v-if="data.location" class="flex w-fit rounded-sm">
          <MarkerIcon class="mr-2 w-4 text-blue-800" />
          <p>{{ data.location }}</p>
        </div>
        <!-- LANGUAGE -->
        <div v-if="data.languages" class="flex w-fit rounded-sm">
          <GlobeIcon class="mr-2 w-[1.125rem] text-blue-800" />
          <ul class="flex">
            <li
              v-for="(language, index) in data.languages"
              :key="language.slug"
            >
              <p>
                {{ language.title
                }}{{ index < data.languages.length - 1 ? ',&nbsp;' : '' }}
              </p>
            </li>
          </ul>
        </div>
      </li>

      <ul class="flex-wrap items-center justify-between gap-10 md:flex">
        <!-- PARTICIPANTS -->
        <li
          v-if="data.min_participants && data.max_participants"
          class="mb-1 min-w-[5.5rem] whitespace-nowrap rounded-sm md:mb-0"
        >
          <span>
            {{ data.min_participants }} {{ $t('to') }}
            {{ data.max_participants }}
            {{ $t('participating') }}
          </span>
        </li>

        <!-- REGISTRATION DEADLINE -->
        <li class="mb-4 min-w-[20.125rem] whitespace-nowrap rounded-sm md:mb-0">
          <span v-if="data.registration_deadline">
            {{ $t('registration_deadline_at') }}
            {{ formatDateLong(data.registration_deadline) }}
          </span>
        </li>

        <li>
          <AppButton
            v-if="data.registration_link"
            class="whitespace-nowrap !px-6"
            :to="data.registration_link"
          >
            {{ $t('enroll_now') }}
          </AppButton>
        </li>
      </ul>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true },
})

const { locale } = useI18n()

function formatDateFull(date) {
  if (!date) {
    return ''
  }
  return new Date(date).toLocaleDateString('de', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

function formatDateLong(date) {
  if (!date) {
    return ''
  }

  return new Date(date).toLocaleDateString(locale.value, {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
}
</script>
